import { Component, OnInit, Input, Output, EventEmitter, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { BaseComponent } from 'src/app/_base/base.component';
import { SocialLearningPostGet, PostGetResult, PostShared } from 'src/app/_models';
import { Subscription } from 'rxjs';
import { SocialLearningService } from 'src/app/_services';

@Component({
  selector: 'app-whatsapp-list',
  templateUrl: './whatsapp-list.component.html',
  styleUrls: ['./whatsapp-list.component.scss']
})
export class WhatsappListComponent extends BaseComponent implements OnInit, OnDestroy {
  @Input()
  activeNote: PostGetResult = null;
  @Output()
  activeNoteEmitter: EventEmitter<PostGetResult> = new EventEmitter<PostGetResult>();
  @ViewChild('notesContainer') private notesContainer: ElementRef;
  notes: PostGetResult[] = [];
  isActive: boolean = false;
  pageSize: number = 6;
  pageIndex: number = 1;
  totalRecord: number = 0;
  activeIndex: number = null;
  subscription: Subscription;
  constructor(private socialLearningService: SocialLearningService) {
    super();
  }

  ngOnInit() {
    this.getPostNotes();
    this.subscription = this.mainFilterObservable$.subscribe(() => {
      this.pageIndex = 1;
      this.getPostNotes();
    });
  }
  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
  getPostNotes(): void {
    this.isActive = true;
    this.socialLearningService.GetNotePost(this.pageSize, this.pageIndex).subscribe(
      (data: SocialLearningPostGet) => {
        if (data) {
          this.totalRecord = data.totalRecords;
          if (this.pageIndex > 1)
            data.results.map(item => {
              this.notes.push(item);
            });
          else this.notes = data.results;
        }
        // if (!this.directiveRef.scrollable() && this.totalRecord > this.notes.length) {
        //   this.pageIndex += 1;
        //   this.getPostNotes();
        // } else
        setTimeout(() => {
          this.onScroll();
        }, 50);
        this.isActive = false;
      },
      () => {
        this.isActive = false;
      }
    );
  }
  noteClicked(activeNote: PostGetResult, noteIndex: number): void {
    this.activeIndex = noteIndex;
    this.activeNoteEmitter.emit(activeNote);
  }
  getUserImage(postShared: PostShared): string {
    return postShared && postShared.studentImage !== null && this.getImage(postShared.studentImage)
      ? this.getImage(postShared.studentImage)
      : './assets/Images/users/default-user.jpg';
  }
  onScroll(): void {
    if (this.totalRecord > this.notes.length) {
      const position = this.notesContainer.nativeElement.scrollTop + this.notesContainer.nativeElement.offsetHeight;
      if (position === this.notesContainer.nativeElement.scrollHeight) {
        this.pageIndex += 1;
        this.getPostNotes();
      }
    }
  }
}
